export const colors = {
  orange: '#EA5A2E',
  white: '#ffffff',
  black: '#111111',
  grey: '#707070',
  lightgrey: '#DCDCDC',
  unavailabe: '#B8B8B8',
};
